import Home from '@/components/page/Home';
import Channel from '@/components/page/Channel';
import Users from '@/components/Users';

// Routes
const routes = [
    {
        path: '',
        name: 'home',
        component: Home
    },
    {
        path:'/channel/:channelUid',
        name: 'channel',
        component: Channel,
    },
    {
        path:'/users',
        name: 'users',
        component: Users,
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js